import {API_BASE} from "../config/env";
import axios from 'axios';

export const FETCH_INVOICES_PENDING = "FETCH_INVOICES_PENDING";
export const FETCH_INVOICES_FULFILLED = "FETCH_INVOICES_FULFILLED";
export const FETCH_INVOICES_REJECTED = "FETCH_INVOICES_REJECTED";



export function fetchInvoices({selectedCorp, subscriberNo}) {

    let databody = {
        corpCode: selectedCorp.value,
        subscriberNo: subscriberNo
    };

    return dispatch => {
        dispatch({
            type : "FETCH_INVOICES",
            payload :  axios.post(`${API_BASE}/inquireInvoice`,databody)
                .then(result => result.data)
        })
    }
}
